import analyticsService from 'services/analytics.service';
import { AlgoliaResponseObject } from 'components/modules/QuickView/components/Reviewable/Reviewable';
import events from './events';

type BuyNowBookEventProps = Pick<
  AlgoliaResponseObject,
  'search_price' | 'search_document_klass' | 'search_url'
>;
const buyNowBookClickEvent = ({
  search_price,
  search_url,
  search_document_klass,
}: BuyNowBookEventProps) => {
  analyticsService.track(events.BUY_NOW_CLICK, {
    location: 'recipe detail quick-view',
    price: search_price,
    affiliate_url: `${search_url}?sourcekey=CAAD1BKQ0`,
    retailer: 'ATK Shop',
    documentType: search_document_klass,
  });
};

export default buyNowBookClickEvent;
